"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.regexp.to-string.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.function.name.js");
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _size = _interopRequireDefault(require("lodash/size"));
var _section = require("@nucleo/section");
var _product = require("@nucleo/product");
function cov_2hlvwxm184() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/catalog/lib/model.js";
  var hash = "220561741728034371be59b37478ab7fbb7c3035";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/catalog/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 140,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 91
        }
      },
      "2": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "3": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 25
        }
      },
      "4": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 25
        }
      },
      "5": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 22
        }
      },
      "6": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 22
        }
      },
      "7": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 22
        }
      },
      "8": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 40,
          column: 3
        }
      },
      "9": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 139,
          column: 7
        }
      },
      "10": {
        start: {
          line: 43,
          column: 29
        },
        end: {
          line: 139,
          column: 5
        }
      },
      "11": {
        start: {
          line: 46,
          column: 23
        },
        end: {
          line: 46,
          column: 24
        }
      },
      "12": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 137,
          column: 10
        }
      },
      "13": {
        start: {
          line: 50,
          column: 27
        },
        end: {
          line: 50,
          column: 52
        }
      },
      "14": {
        start: {
          line: 51,
          column: 41
        },
        end: {
          line: 51,
          column: 73
        }
      },
      "15": {
        start: {
          line: 52,
          column: 28
        },
        end: {
          line: 52,
          column: 30
        }
      },
      "16": {
        start: {
          line: 53,
          column: 12
        },
        end: {
          line: 55,
          column: 15
        }
      },
      "17": {
        start: {
          line: 54,
          column: 14
        },
        end: {
          line: 54,
          column: 99
        }
      },
      "18": {
        start: {
          line: 56,
          column: 26
        },
        end: {
          line: 62,
          column: 17
        }
      },
      "19": {
        start: {
          line: 63,
          column: 32
        },
        end: {
          line: 63,
          column: 73
        }
      },
      "20": {
        start: {
          line: 65,
          column: 43
        },
        end: {
          line: 65,
          column: 68
        }
      },
      "21": {
        start: {
          line: 70,
          column: 12
        },
        end: {
          line: 125,
          column: 13
        }
      },
      "22": {
        start: {
          line: 71,
          column: 14
        },
        end: {
          line: 100,
          column: 17
        }
      },
      "23": {
        start: {
          line: 72,
          column: 16
        },
        end: {
          line: 72,
          column: 69
        }
      },
      "24": {
        start: {
          line: 73,
          column: 16
        },
        end: {
          line: 82,
          column: 18
        }
      },
      "25": {
        start: {
          line: 84,
          column: 16
        },
        end: {
          line: 94,
          column: 17
        }
      },
      "26": {
        start: {
          line: 85,
          column: 18
        },
        end: {
          line: 93,
          column: 22
        }
      },
      "27": {
        start: {
          line: 85,
          column: 67
        },
        end: {
          line: 93,
          column: 19
        }
      },
      "28": {
        start: {
          line: 95,
          column: 16
        },
        end: {
          line: 99,
          column: 18
        }
      },
      "29": {
        start: {
          line: 101,
          column: 14
        },
        end: {
          line: 101,
          column: 28
        }
      },
      "30": {
        start: {
          line: 103,
          column: 14
        },
        end: {
          line: 112,
          column: 16
        }
      },
      "31": {
        start: {
          line: 114,
          column: 14
        },
        end: {
          line: 123,
          column: 15
        }
      },
      "32": {
        start: {
          line: 115,
          column: 16
        },
        end: {
          line: 122,
          column: 20
        }
      },
      "33": {
        start: {
          line: 115,
          column: 73
        },
        end: {
          line: 122,
          column: 17
        }
      },
      "34": {
        start: {
          line: 124,
          column: 14
        },
        end: {
          line: 124,
          column: 28
        }
      },
      "35": {
        start: {
          line: 127,
          column: 12
        },
        end: {
          line: 135,
          column: 14
        }
      },
      "36": {
        start: {
          line: 142,
          column: 21
        },
        end: {
          line: 183,
          column: 1
        }
      },
      "37": {
        start: {
          line: 144,
          column: 20
        },
        end: {
          line: 144,
          column: 36
        }
      },
      "38": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 153,
          column: 5
        }
      },
      "39": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 89
        }
      },
      "40": {
        start: {
          line: 147,
          column: 54
        },
        end: {
          line: 147,
          column: 87
        }
      },
      "41": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 152,
          column: 8
        }
      },
      "42": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 19
        }
      },
      "43": {
        start: {
          line: 159,
          column: 22
        },
        end: {
          line: 159,
          column: 86
        }
      },
      "44": {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 164,
          column: 6
        }
      },
      "45": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 167,
          column: 6
        }
      },
      "46": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 179,
          column: 5
        }
      },
      "47": {
        start: {
          line: 172,
          column: 29
        },
        end: {
          line: 172,
          column: 87
        }
      },
      "48": {
        start: {
          line: 174,
          column: 28
        },
        end: {
          line: 174,
          column: 85
        }
      },
      "49": {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 178,
          column: 8
        }
      },
      "50": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 28
        }
      },
      "51": {
        start: {
          line: 182,
          column: 22
        },
        end: {
          line: 182,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 12
          }
        },
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 91
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 9,
            column: 15
          },
          end: {
            line: 9,
            column: 16
          }
        },
        loc: {
          start: {
            line: 9,
            column: 27
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 9
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 24,
            column: 26
          }
        },
        loc: {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 42,
            column: 25
          },
          end: {
            line: 42,
            column: 26
          }
        },
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 139,
            column: 7
          }
        },
        line: 43
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 43,
            column: 17
          },
          end: {
            line: 43,
            column: 18
          }
        },
        loc: {
          start: {
            line: 43,
            column: 29
          },
          end: {
            line: 139,
            column: 5
          }
        },
        line: 43
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 45,
            column: 37
          },
          end: {
            line: 45,
            column: 38
          }
        },
        loc: {
          start: {
            line: 45,
            column: 48
          },
          end: {
            line: 138,
            column: 7
          }
        },
        line: 45
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 49,
            column: 35
          },
          end: {
            line: 49,
            column: 36
          }
        },
        loc: {
          start: {
            line: 49,
            column: 52
          },
          end: {
            line: 136,
            column: 11
          }
        },
        line: 49
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 53,
            column: 47
          },
          end: {
            line: 53,
            column: 48
          }
        },
        loc: {
          start: {
            line: 53,
            column: 52
          },
          end: {
            line: 55,
            column: 13
          }
        },
        line: 53
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 71,
            column: 71
          },
          end: {
            line: 71,
            column: 72
          }
        },
        loc: {
          start: {
            line: 71,
            column: 92
          },
          end: {
            line: 100,
            column: 15
          }
        },
        line: 71
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 85,
            column: 59
          },
          end: {
            line: 85,
            column: 60
          }
        },
        loc: {
          start: {
            line: 85,
            column: 67
          },
          end: {
            line: 93,
            column: 19
          }
        },
        line: 85
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 115,
            column: 65
          },
          end: {
            line: 115,
            column: 66
          }
        },
        loc: {
          start: {
            line: 115,
            column: 73
          },
          end: {
            line: 122,
            column: 17
          }
        },
        line: 115
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 143,
            column: 7
          },
          end: {
            line: 143,
            column: 8
          }
        },
        loc: {
          start: {
            line: 143,
            column: 25
          },
          end: {
            line: 156,
            column: 3
          }
        },
        line: 143
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 147,
            column: 43
          },
          end: {
            line: 147,
            column: 44
          }
        },
        loc: {
          start: {
            line: 147,
            column: 54
          },
          end: {
            line: 147,
            column: 87
          }
        },
        line: 147
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 158,
            column: 18
          },
          end: {
            line: 158,
            column: 19
          }
        },
        loc: {
          start: {
            line: 158,
            column: 59
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 158
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 169,
            column: 15
          },
          end: {
            line: 169,
            column: 16
          }
        },
        loc: {
          start: {
            line: 169,
            column: 33
          },
          end: {
            line: 181,
            column: 3
          }
        },
        line: 169
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 182,
            column: 11
          },
          end: {
            line: 182,
            column: 12
          }
        },
        loc: {
          start: {
            line: 182,
            column: 22
          },
          end: {
            line: 182,
            column: 38
          }
        },
        line: 182
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 11
          }
        }, {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 33
          }
        }, {
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 61
          }
        }, {
          start: {
            line: 7,
            column: 65
          },
          end: {
            line: 7,
            column: 90
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 12,
            column: 25
          }
        }, {
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 14,
            column: 25
          }
        }, {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 16,
            column: 22
          }
        }, {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 18,
            column: 22
          }
        }, {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 20,
            column: 22
          }
        }],
        line: 10
      },
      "2": {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 15
          }
        }, {
          start: {
            line: 34,
            column: 19
          },
          end: {
            line: 34,
            column: 37
          }
        }],
        line: 34
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 11
          },
          end: {
            line: 36,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 36,
            column: 23
          },
          end: {
            line: 36,
            column: 40
          }
        }, {
          start: {
            line: 36,
            column: 43
          },
          end: {
            line: 36,
            column: 48
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 56,
            column: 26
          },
          end: {
            line: 62,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 58
          }
        }, {
          start: {
            line: 58,
            column: 16
          },
          end: {
            line: 62,
            column: 17
          }
        }],
        line: 56
      },
      "5": {
        loc: {
          start: {
            line: 70,
            column: 12
          },
          end: {
            line: 125,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 12
          },
          end: {
            line: 125,
            column: 13
          }
        }, {
          start: {
            line: 102,
            column: 19
          },
          end: {
            line: 125,
            column: 13
          }
        }],
        line: 70
      },
      "6": {
        loc: {
          start: {
            line: 72,
            column: 27
          },
          end: {
            line: 72,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 45
          },
          end: {
            line: 72,
            column: 53
          }
        }, {
          start: {
            line: 72,
            column: 56
          },
          end: {
            line: 72,
            column: 68
          }
        }],
        line: 72
      },
      "7": {
        loc: {
          start: {
            line: 84,
            column: 16
          },
          end: {
            line: 94,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 16
          },
          end: {
            line: 94,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 84
      },
      "8": {
        loc: {
          start: {
            line: 86,
            column: 24
          },
          end: {
            line: 86,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 24
          },
          end: {
            line: 86,
            column: 30
          }
        }, {
          start: {
            line: 86,
            column: 34
          },
          end: {
            line: 86,
            column: 51
          }
        }],
        line: 86
      },
      "9": {
        loc: {
          start: {
            line: 88,
            column: 22
          },
          end: {
            line: 88,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 22
          },
          end: {
            line: 88,
            column: 90
          }
        }, {
          start: {
            line: 88,
            column: 94
          },
          end: {
            line: 88,
            column: 96
          }
        }],
        line: 88
      },
      "10": {
        loc: {
          start: {
            line: 90,
            column: 22
          },
          end: {
            line: 91,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 22
          },
          end: {
            line: 90,
            column: 97
          }
        }, {
          start: {
            line: 91,
            column: 22
          },
          end: {
            line: 91,
            column: 24
          }
        }],
        line: 90
      },
      "11": {
        loc: {
          start: {
            line: 114,
            column: 14
          },
          end: {
            line: 123,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 14
          },
          end: {
            line: 123,
            column: 15
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 114
      },
      "12": {
        loc: {
          start: {
            line: 116,
            column: 22
          },
          end: {
            line: 116,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 22
          },
          end: {
            line: 116,
            column: 28
          }
        }, {
          start: {
            line: 116,
            column: 32
          },
          end: {
            line: 116,
            column: 49
          }
        }],
        line: 116
      },
      "13": {
        loc: {
          start: {
            line: 117,
            column: 24
          },
          end: {
            line: 117,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 117,
            column: 24
          },
          end: {
            line: 117,
            column: 92
          }
        }, {
          start: {
            line: 117,
            column: 96
          },
          end: {
            line: 117,
            column: 98
          }
        }],
        line: 117
      },
      "14": {
        loc: {
          start: {
            line: 119,
            column: 20
          },
          end: {
            line: 120,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 20
          },
          end: {
            line: 119,
            column: 95
          }
        }, {
          start: {
            line: 120,
            column: 20
          },
          end: {
            line: 120,
            column: 22
          }
        }],
        line: 119
      },
      "15": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 146
      },
      "16": {
        loc: {
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 146,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 146,
            column: 21
          }
        }, {
          start: {
            line: 146,
            column: 25
          },
          end: {
            line: 146,
            column: 45
          }
        }],
        line: 146
      },
      "17": {
        loc: {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 179,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 179,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 170
      },
      "18": {
        loc: {
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 170,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 170,
            column: 21
          }
        }, {
          start: {
            line: 170,
            column: 25
          },
          end: {
            line: 170,
            column: 45
          }
        }],
        line: 170
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "220561741728034371be59b37478ab7fbb7c3035"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hlvwxm184 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2hlvwxm184();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var AnalyticProductModel = (cov_2hlvwxm184().s[0]++, {
  getName: function getName(rawName, language, defaultLanguage) {
    cov_2hlvwxm184().f[0]++;
    cov_2hlvwxm184().s[1]++;
    return (cov_2hlvwxm184().b[0][0]++, rawName) && ((cov_2hlvwxm184().b[0][1]++, rawName[language]) || (cov_2hlvwxm184().b[0][2]++, rawName[defaultLanguage]) || (cov_2hlvwxm184().b[0][3]++, (0, _values.default)(rawName)[0]));
  },
  getTourName: function getTourName(language) {
    cov_2hlvwxm184().f[1]++;
    cov_2hlvwxm184().s[2]++;
    switch (language) {
      case 'de':
        cov_2hlvwxm184().b[1][0]++;
        cov_2hlvwxm184().s[3]++;
        return 'Tournee';
      case 'fr':
        cov_2hlvwxm184().b[1][1]++;
        cov_2hlvwxm184().s[4]++;
        return 'Tournée';
      case 'es':
        cov_2hlvwxm184().b[1][2]++;
        cov_2hlvwxm184().s[5]++;
        return 'Gira';
      case 'ca':
        cov_2hlvwxm184().b[1][3]++;
        cov_2hlvwxm184().s[6]++;
        return 'Gira';
      default:
        cov_2hlvwxm184().b[1][4]++;
        cov_2hlvwxm184().s[7]++;
        return 'Tour';
    }
  },
  buildProductDataLayer: function buildProductDataLayer(item, section, language, defaultLanguage, subTopics, brand, productType, position) {
    cov_2hlvwxm184().f[2]++;
    cov_2hlvwxm184().s[8]++;
    return {
      id: (cov_2hlvwxm184().b[2][0]++, item.id) && (cov_2hlvwxm184().b[2][1]++, item.id.toString()),
      name: AnalyticProductModel.getName(item.rawName, language, defaultLanguage),
      brand: subTopics ? (cov_2hlvwxm184().b[3][0]++, brand + subTopics) : (cov_2hlvwxm184().b[3][1]++, brand),
      type: productType,
      position: position,
      list: AnalyticProductModel.getName(section.rawName, language, defaultLanguage)
    };
  },
  buildDataForDataLayer: function buildDataForDataLayer(sections, language, defaultLanguage) {
    cov_2hlvwxm184().f[3]++;
    cov_2hlvwxm184().s[9]++;
    return sections.map(function (section) {
      cov_2hlvwxm184().f[4]++;
      cov_2hlvwxm184().s[10]++;
      return _objectSpread(_objectSpread({}, section), {}, {
        clusters: section.clusters.map(function (cluster) {
          cov_2hlvwxm184().f[5]++;
          var position = (cov_2hlvwxm184().s[11]++, 0);
          cov_2hlvwxm184().s[12]++;
          return _objectSpread(_objectSpread({}, cluster), {}, {
            items: cluster.items.map(function (item, index) {
              cov_2hlvwxm184().f[6]++;
              var isTour = (cov_2hlvwxm184().s[13]++, item.displayAs === 'TOUR');
              var displayAsPerformance = (cov_2hlvwxm184().s[14]++, item.displayAs === 'PERFORMANCE');
              var subTopics = (cov_2hlvwxm184().s[15]++, '');
              cov_2hlvwxm184().s[16]++;
              item.product.subTopicsList.forEach(function (t) {
                cov_2hlvwxm184().f[7]++;
                cov_2hlvwxm184().s[17]++;
                subTopics += " / ".concat(AnalyticProductModel.getName(t.name, language, defaultLanguage));
              });
              var brand = (cov_2hlvwxm184().s[18]++, isTour ? (cov_2hlvwxm184().b[4][0]++, AnalyticProductModel.getTourName(language)) : (cov_2hlvwxm184().b[4][1]++, AnalyticProductModel.getName(item.product.productFamilyName, language, defaultLanguage)));
              var productType = (cov_2hlvwxm184().s[19]++, _product.ProductModel.getProductType(item.product));
              var performanceWithDataLayer = (cov_2hlvwxm184().s[20]++, item.product.performances);
              var advantageDataLayer;
              var productDataLayer;

              // Handle in case data on landing page will display as performance
              cov_2hlvwxm184().s[21]++;
              if (displayAsPerformance) {
                cov_2hlvwxm184().b[5][0]++;
                cov_2hlvwxm184().s[22]++;
                performanceWithDataLayer = item.product.performances.map(function (perf, perfIndex) {
                  cov_2hlvwxm184().f[8]++;
                  cov_2hlvwxm184().s[23]++;
                  position = perfIndex === 0 ? (cov_2hlvwxm184().b[6][0]++, position) : (cov_2hlvwxm184().b[6][1]++, position + 1);
                  cov_2hlvwxm184().s[24]++;
                  productDataLayer = AnalyticProductModel.buildProductDataLayer(perf, section, language, defaultLanguage, subTopics, brand, productType, position);
                  cov_2hlvwxm184().s[25]++;
                  if ((0, _size.default)(perf.advantages) > 0) {
                    cov_2hlvwxm184().b[7][0]++;
                    cov_2hlvwxm184().s[26]++;
                    advantageDataLayer = perf.advantages.map(function (adv) {
                      cov_2hlvwxm184().f[9]++;
                      cov_2hlvwxm184().s[27]++;
                      return {
                        id: (cov_2hlvwxm184().b[8][0]++, adv.id) && (cov_2hlvwxm184().b[8][1]++, adv.id.toString()),
                        name: (cov_2hlvwxm184().b[9][0]++, AnalyticProductModel.getName(adv.rawName, language, defaultLanguage)) || (cov_2hlvwxm184().b[9][1]++, ''),
                        creative: (cov_2hlvwxm184().b[10][0]++, AnalyticProductModel.getName(adv.rawDescription, language, defaultLanguage)) || (cov_2hlvwxm184().b[10][1]++, ''),
                        position: position
                      };
                    });
                  } else {
                    cov_2hlvwxm184().b[7][1]++;
                  }
                  cov_2hlvwxm184().s[28]++;
                  return _objectSpread(_objectSpread({}, perf), {}, {
                    productDataLayer: productDataLayer,
                    advantageDataLayer: advantageDataLayer
                  });
                });
                cov_2hlvwxm184().s[29]++;
                position += 1;
              } else {
                cov_2hlvwxm184().b[5][1]++;
                cov_2hlvwxm184().s[30]++;
                productDataLayer = AnalyticProductModel.buildProductDataLayer(item.product, section, language, defaultLanguage, subTopics, brand, productType, position);
                cov_2hlvwxm184().s[31]++;
                if ((0, _size.default)(item.product.advantages) > 0) {
                  cov_2hlvwxm184().b[11][0]++;
                  cov_2hlvwxm184().s[32]++;
                  advantageDataLayer = item.product.advantages.map(function (adv) {
                    cov_2hlvwxm184().f[10]++;
                    cov_2hlvwxm184().s[33]++;
                    return {
                      id: (cov_2hlvwxm184().b[12][0]++, adv.id) && (cov_2hlvwxm184().b[12][1]++, adv.id.toString()),
                      name: (cov_2hlvwxm184().b[13][0]++, AnalyticProductModel.getName(adv.rawName, language, defaultLanguage)) || (cov_2hlvwxm184().b[13][1]++, ''),
                      creative: (cov_2hlvwxm184().b[14][0]++, AnalyticProductModel.getName(adv.rawDescription, language, defaultLanguage)) || (cov_2hlvwxm184().b[14][1]++, ''),
                      position: position
                    };
                  });
                } else {
                  cov_2hlvwxm184().b[11][1]++;
                }
                cov_2hlvwxm184().s[34]++;
                position += 1;
              }
              cov_2hlvwxm184().s[35]++;
              return _objectSpread(_objectSpread({}, item), {}, {
                product: _objectSpread(_objectSpread({}, item.product), {}, {
                  productDataLayer: productDataLayer,
                  advantageDataLayer: advantageDataLayer,
                  performances: performanceWithDataLayer
                })
              });
            })
          });
        })
      });
    });
  }
});
var CatalogModel = (cov_2hlvwxm184().s[36]++, {
  get: function get(data, config) {
    cov_2hlvwxm184().f[11]++;
    var catalog = (cov_2hlvwxm184().s[37]++, {
      sections: []
    });
    cov_2hlvwxm184().s[38]++;
    if ((cov_2hlvwxm184().b[16][0]++, data.sections) && (cov_2hlvwxm184().b[16][1]++, data.sections.length)) {
      cov_2hlvwxm184().b[15][0]++;
      cov_2hlvwxm184().s[39]++;
      catalog.sections = data.sections.map(function (section) {
        cov_2hlvwxm184().f[12]++;
        cov_2hlvwxm184().s[40]++;
        return _section.SectionModel.get(section, config);
      });
      cov_2hlvwxm184().s[41]++;
      catalog.sections = AnalyticProductModel.buildDataForDataLayer(catalog.sections, config.language, config.defaultLanguage);
    } else {
      cov_2hlvwxm184().b[15][1]++;
    }
    cov_2hlvwxm184().s[42]++;
    return catalog;
  },
  changeLanguage: function changeLanguage(language, defaultLanguage, sections) {
    cov_2hlvwxm184().f[13]++;
    var newSections = (cov_2hlvwxm184().s[43]++, _section.SectionModel.changeLanguage(language, defaultLanguage, sections));
    cov_2hlvwxm184().s[44]++;
    newSections = AnalyticProductModel.buildDataForDataLayer(newSections, language, defaultLanguage);
    cov_2hlvwxm184().s[45]++;
    return {
      sections: newSections
    };
  },
  getCalendar: function getCalendar(data, config) {
    cov_2hlvwxm184().f[14]++;
    cov_2hlvwxm184().s[46]++;
    if ((cov_2hlvwxm184().b[18][0]++, data.sections) && (cov_2hlvwxm184().b[18][1]++, data.sections.length)) {
      cov_2hlvwxm184().b[17][0]++;
      // create the section pattern
      var sectionPattern = (cov_2hlvwxm184().s[47]++, (0, _assign.default)({}, data.sections[0], {
        classifyBy: 'DAY'
      }));
      // merge all the section into one
      var mergedSection = (cov_2hlvwxm184().s[48]++, _section.SectionModel.mergeSections(data.sections, sectionPattern));
      // use the model to create the section
      cov_2hlvwxm184().s[49]++;
      return {
        sections: [_section.SectionModel.get(mergedSection, config)]
      };
    } else {
      cov_2hlvwxm184().b[17][1]++;
    }
    cov_2hlvwxm184().s[50]++;
    return {
      sections: []
    };
  },
  hasData: function hasData(catalog) {
    cov_2hlvwxm184().f[15]++;
    cov_2hlvwxm184().s[51]++;
    return catalog.sections;
  }
});
var _default = exports.default = CatalogModel;